import { defineStore } from "pinia";

const DEFAULT_TIMEOUT = 5000;

type TLinkAction = {
    to: string | Record<string, unknown>;
    label: string;
};

export type ToastType = "neutral" | "positive" | "warning" | "negative";

export const useAppStateStore = defineStore("appState", {
    state: () => ({
        toastMsg: null as string | null,
        toastType: "neutral" as ToastType,
        toastAction: null as TLinkAction | null,
        timeoutHandler: null as ReturnType<typeof setTimeout> | null,
        homeGreetingAnimated: false,
    }),
    actions: {
        toast(msg: string, type: ToastType = "neutral", action?: TLinkAction) {
            if (this.timeoutHandler) {
                clearTimeout(this.timeoutHandler);
            }
            this.toastMsg = msg;
            this.toastType = type;
            this.toastAction = action ?? null;
            this.timeoutHandler = setTimeout(() => {
                this.clearToast();
            }, DEFAULT_TIMEOUT);
        },
        errorToast(msg: string) {
            this.toast(msg, "negative");
        },
        infoToast(msg: string, action?: TLinkAction) {
            this.toast(msg, "positive", action);
        },
        warningToast(msg: string) {
            this.toast(msg, "warning");
        },
        clearToast() {
            this.toastMsg = null;
            this.toastType = "neutral";
            this.toastAction = null;
            if (this.timeoutHandler) {
                clearTimeout(this.timeoutHandler);
            }
            this.timeoutHandler = null;
        },
        clearErrorToast() {
            this.clearToast();
        },
        clearInfoToast() {
            this.clearToast();
        },
        setHomeGreetingAnimated() {
            this.homeGreetingAnimated = true;
        },
    },
});
